import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCC_API } from '@/service'
const api = {
  spuListByCate:
    PREFIX_SCC_API + 'fchild/worker/queryCityAndLevel4CategorySpus.do',
  spuListByStore: PREFIX_SCC_API + 'fchild/worker/queryStoreSpuList.do',
  spuListByShare:
    PREFIX_SCC_API + 'fchild/worker/queryCityAndLevel4CategorySpusForShare.do'
}
export default {
  async getCateOrCitySkus(
    { commit },
    { citycode, binary, pageSize, pageLength, districtId, isSelf, businessId }
  ) {
    try {
      const query = queryString.stringify({
        cityId: citycode,
        level4CategoryId: binary,
        pageIndex: pageSize,
        pageSize: pageLength,
        districtId,
        isSelf,
        businessId
      })
      const res = await fetch(`${api.spuListByCate}?${query}`)
      const resJson = await res.json()
      if (resJson.code === '1') {
        if (pageSize === 1) {
          commit('resetServiceListByCate')
        }
        commit('setServiceListByCate', resJson.data || [])
      }
      return resJson
    } catch (e) {
      console.log(e)
    }
  },
  async getStoreServices(
    { commit },
    {
      storeCode,
      pageIndex,
      pageSize,
      districtId,
      level4CategoryId,
      isSelf,
      businessId
    }
  ) {
    try {
      const query = queryString.stringify({
        storeCode,
        pageSize,
        pageIndex,
        level4CategoryId,
        districtId,
        businessId,
        isSelf
      })
      const service_res = await fetch(`${api.spuListByStore}?${query}`)
      const serviceJson = await service_res.json()
      if (serviceJson.code * 1 === 1) {
        if (pageIndex === 1) {
          commit('reSetStoreServices')
        }
        commit('setStoreServices', serviceJson.data || [])
      }
      return serviceJson
    } catch (e) {
      console.log(e)
    }
  },
  async getCateOrCitySkus4Share(
    { commit },
    { citycode, binary, pageSize, pageLength, districtId, isSelf, businessId }
  ) {
    try {
      const query = queryString.stringify({
        cityId: citycode,
        level4CategoryIds: binary,
        pageIndex: pageSize,
        pageSize: pageLength,
        districtId,
        isSelf,
        businessId
      })
      const res = await fetch(`${api.spuListByShare}?${query}`)
      const resJson = await res.json()
      if (resJson.code === '1') {
        if (pageSize === 1) {
          commit('resetServiceListByCate')
        }
        commit('setServiceListByCate', resJson.data || [])
      }
      return resJson.data
    } catch (e) {
      console.log(e)
    }
  }
}
